<template>
    <div class="work-info">
        <div class="loading-box"  v-show="showLoading">
            <div class="content" >
                <div class="point1"></div>
                <div class="point2"></div>
                <div class="point3"></div>
            </div>
        </div>
        <div class="all-box-work"  v-show="!showLoading">
            <div class="info-all-main-box" v-show="success === ''">
                <div class="info-box-s1">
                    <p class="pp1">{{infoObj.jiaBanRenName}}提出的加班举证申请</p>
                </div>
                <div class="info-box-s2">
                    <div class="info-box-s2-main">
                        <p class="time-title">加班 {{infoObj.jiaBanShiChang}} 小时</p>
                        <div class="time-box">
                            <div class="left-time">
                                <span class="dian"></span>
                                <span class="line"></span>
                                <span class="dian"></span>
                            </div>
                            <div class="right-time">
                                <p class="time1">{{infoObj.jiaBanStartDate}}</p>
                                <p class="time2">{{infoObj.jiaBanEndDate}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-box-s3">
                    <div class="detail-title">加班明细</div>
                    <div class="common-detial-title">加班说明</div>
                    <div class="shuoming-box">
                        <span>{{infoObj.jiaBanReason?infoObj.jiaBanReason:'暂无加班说明'}}</span>
                    </div>
                    <div class="common-detial-title" v-show="infoObj.guijitupianList && infoObj.guijitupianList.length > 0">打卡照片</div>
                    <div class="waibo-box waibo-box-daka" v-show="infoObj.guijitupianList && infoObj.guijitupianList.length > 0">
                        <div class="detial-img-box">
                            <div class="img-box" v-for="(item,index) in infoObj.guijitupianList" :key="index" @click="clickImg(item,index)">
                                <img :src="item" alt="" >
                            </div>
                        </div>
                    </div>
                    <div class="common-detial-title" v-show="infoObj.currentLink !== 'apply'">备注</div>
                    <div class="shuoming-box" v-show="infoObj.currentLink !== 'apply'">
                        <span>{{infoObj.workNode?infoObj.workNode:'暂无备注'}}</span>
                    </div>
                    <div class="common-detial-title" v-show="infoObj.currentLink !== 'apply'">工作内容</div>
                    <div class="waibo-box" v-show="infoObj.currentLink !== 'apply'">
                        <div class="detial-img-box" v-show="infoObj.photoList !== null">
                            <div class="img-box" v-for="(item,index) in infoObj.photoList" :key="index" @click="clickFujian(item)">
                                <img :src="item.url" alt="" >
                                <div class="name-box"><span>{{item.name}}</span></div>
                            </div>
                        </div>
                        <div class="shuoming-box" v-show="infoObj.photoList === null">
                            <span>暂无工作内容信息</span>
                        </div>
                    </div>
                </div>
                <!-- 申请人加班 -->
                <div class="write-box" v-show="infoObj.currentLink === 'apply'">
                    <div class="write-box-lis">
                        <div class="title-box">
                            <span><img class="img-must" src="../assets/imgs/img-must-write.png" alt="">工作内容（上传附件）</span>
                            <van-uploader   max-count="30" multiple="true" :after-read="afterRead"  accept="" @click-upload="uploadHandler">
                                <div class="upload-add-box">
                                    <img src="../assets/imgs/img-upload.png" alt="" class="img-upload">
                                </div>
                            </van-uploader>
                        </div>
                        <div class="daka-img-box" v-show="fujianList.length > 0">
                            <div class="img-box" v-for="(item,index) in fujianList" :key="index" >
                                <img :src="item.url" alt="" >
                                <img src="../assets/imgs/img-quxiao.png" alt="" class="quxiao" @click="clickQuxiaoHandler(item)">
                                <div class="name-box"><span>{{item.name}}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="write-box" v-show="infoObj.currentLink === 'apply'">
                    <div class="write-box-lis">
                        <div class="title-box">
                            <span><img class="img-must" src="../assets/imgs/img-must-write.png" alt="">备注</span>
                        </div>
                        <div class="lis-bom">
                            <div class="lis-bom-main">
                                <van-field v-model="message" autosize type="textarea" placeholder="请输入备注" @input="inputHandler"/>
                            </div>
                        </div>
                    </div>
                </div>
                <img class="img-zhuangtai" src="../assets/imgs/icon-tongguo.png" alt="" v-show="infoObj.currentLink !== 'apply' && infoObj.checkState === '通过'">
                <img class="img-zhuangtai" src="../assets/imgs/icon-bohui.png" alt="" v-show="infoObj.currentLink !== 'apply' && infoObj.checkState === '驳回'">
                <img class="img-zhuangtai" src="../assets/imgs/icon-daishenpin.png" alt="" v-show="infoObj.currentLink !== 'apply' && infoObj.checkState === '待审批'">
                <img class="img-zhuangtai" src="../assets/imgs/icon-jinxingzhong.png" alt="" v-show="infoObj.currentLink !== 'apply' && infoObj.checkState === '进行中'">
                <img class="img-zhuangtai" src="../assets/imgs/icon-butongguo.png" alt="" v-show="infoObj.currentLink !== 'apply' && infoObj.checkState === '不通过'">
                <div class="liucheng-box">
                    <div class="liucheng-title">流程</div>
                    <div class="liucheng-main-box">
                        <div class="liucheng-main-lis" v-for="(item,index) in liuchengList" :key="index">
                            <div class="liucheng-lis-left">
                                <img :src="item.checkImage" alt="" class="img-touxiang" v-show="item.checkImage !== null && item.checkImage !== ''">
                                <img src="../assets/imgs/img-no-touxiang copy.png" alt="" class="img-touxiang" v-show="item.checkImage === null || item.checkImage === ''">
                                <div class="wai-box" :style="{background:`${item.bgc}`}">
                                    <img :src="item.imgUrl" alt="" class="img-last">
                                </div>
                                <div class="shuxian-box">
                                    <div class="shuxian-main"></div>
                                </div>
                            </div>
                            <div class="liucheng-lis-right">
                                <div class="right-top-box">
                                    <span>{{item.checkRole}}</span>
                                    <span>{{item.checkDate?item.checkDate.slice(0,16):''}}</span>
                                </div>
                                <div class="right-bom-box">{{item.checkName}} <span v-show="item.status !== ''">{{`（${item.status}）`}}</span> </div>
                                <div class="info-jujue" v-show="item.checkOpinion !== null">{{item.checkOpinion}}</div>
                            </div>
                        </div>
                    </div>    
                </div>
                <div class="liubai-box" v-show="infoObj.currentLink === 'apply'"></div>
                <div class="bom-submit" v-show="infoObj.currentLink === 'apply'">
                    <div class="caogao-box" @click="savehandler">
                        <img src="../assets/imgs/caogao-img.png" alt="" class="img-caogao">
                        <span>存草稿</span>
                    </div>
                    <div class="submit-box" @click="clicSubmit">提交</div>
                </div>
            </div>
            <div class="chengg-box" v-show="success !== ''">
                <img src="../assets/imgs/img-success.png" alt="" class="img-success" v-show="success === 'success'">
                <img src="../assets/imgs/img-shibai.jpg" alt="" class="img-success" v-show="success === 'fail'">
                <p class="text-s">{{success === 'success' ? '提交成功' : '提交失败'}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { Tab, Tabs,ImagePreview,Uploader,Field,Toast ,Dialog,Step, Steps ,Search  } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Uploader);
Vue.use(ImagePreview);
Vue.use(Field);
Vue.use(Toast );
Vue.use(Dialog  );
Vue.use(Step);
Vue.use(Steps);
Vue.use(Search);
import * as api from "../api"

import imgTianxie from "../assets/imgs/tianxie-img.png"
import imgSuccess from "../assets/imgs/img-duihao-last.png"
import imgLoading from "../assets/imgs/jinxgzhong-img.png"
import imgCuowu from "../assets/imgs/cuowu-img.png"

export default {
   data() {
    return {
        
        fileList:[],

        infoObj:{},
        id:'',
        fujianList:[],
        message:'',
        success:'',
        showDialog:false,
        liuchengList:[],

        showLoading:false,
    }
   },
   mounted () {
        // this.id = this.$route.query.id
        this.id = this.$route.query.id ? this.$route.query.id : '202307051615000089039'
        this.getData()
        api.getJiabanLiuchengApi(this.id).then(res=>{
            console.log(res.data,"aaa");
            this.liuchengList = res.data.data
            this.liuchengList.forEach(item=>{
                if(item.checkDate === null){
                    item.times = ''
                }else{
                    item.times = new Date(item.checkDate)
                    item.times = this.fillZero(item.times.getMonth()+1)+'.'+this.fillZero(item.times.getDate())+' '+this.fillZero(item.times.getHours())+":"+this.fillZero(item.times.getMinutes())
                }
                if(item.checkRole === '申请人' && item.checkStudent === '0'){
                    item.status = ''
                    item.imgUrl = imgTianxie
                    item.bgc = 'rgb(171,165,255)'
                }else if(item.checkRole === '申请人' && item.checkStudent === '1'){
                    item.status = ''
                    item.imgUrl = imgSuccess
                    item.bgc = '#0aa052'
                }else if(item.checkRole === '部门主管' && item.checkStudent === '0'){
                    item.status = '审批中'
                    item.imgUrl = imgLoading
                    item.bgc = 'rgb(255,146,0)'
                }else if(item.checkRole === '部门主管' && item.checkStudent === '1'){
                    item.status = '通过'
                    item.imgUrl = imgSuccess
                    item.bgc = '#0aa052'
                }else if(item.checkRole === '部门主管' && item.checkStudent === '2'){
                    item.status = '不通过'
                    item.imgUrl = imgCuowu
                    item.bgc = 'red'
                }else if(item.checkRole === '部门主管' && item.checkStudent === '3'){
                    item.status = '驳回'
                    item.imgUrl = imgCuowu
                    item.bgc = 'red'
                }
            })
        })
        
   },
   methods: {
        fillZero(str){
            var realNum;
            if(str < 10){
                realNum	= '0'+str;
            }else{
                realNum	= str;
            }
            return realNum;
        },
        clickFujian(item){
            console.log(item);
            window.open(item.value)
        },
        getData(){
            this.showLoading = true
            api.getJiabanInfoApi(this.id).then(res=>{
                console.log(res.data.data,"aaaaaaaa");
                if(res.data){
                    this.showLoading = false
                    this.infoObj = res.data.data
                    if(this.infoObj.photoList !== null){
                        this.infoObj.photoList.forEach(item=>{
                            if(item.name.indexOf('doc') > -1){
                                item.url = require('../assets/imgs/word-img.png')
                            }else if(item.name.indexOf('xls') > -1){
                                item.url = require('../assets/imgs/excel-img.png')
                            }else if(item.name.indexOf('pdf') > -1){
                                item.url = require('../assets/imgs/pdf-img.png')
                            }else if(item.name.indexOf('zip') > -1){
                                item.url = require('../assets/imgs/yasuobao-img.png')
                            }else if(item.name.indexOf('mp4') > -1){
                                item.url = require('../assets/imgs/video.png')
                            }else if(item.name.indexOf('ppt') > -1){
                                item.url = require('../assets/imgs/ppt-img.png')
                            }else if(item.name.indexOf('txt') > -1){
                                item.url = require('../assets/imgs/tet-img.png')
                            }else if(item.name.indexOf('bmp') > -1 || item.name.indexOf('gif') > -1 || item.name.indexOf('jpg') > -1 || item.name.indexOf('jpeg') > -1 || item.name.indexOf('png') > -1 ){
                                item.url = item.value
                            }else{
                                item.url = require('../assets/imgs/wenjian-imgss.png')
                            }
                        })
                        this.fujianList =  this.infoObj.photoList
                    }else{
                        this.fujianList = []
                    }

                    if(this.infoObj.workNode && this.infoObj.workNode !== null){
                        this.message = this.infoObj.workNode
                    }else{
                        this.message = ''
                    }
                }else{
                    this.showLoading = true
                }

                

                
                
            })
        },
        inputHandler(i){
            console.log(i);
            this.message = i.trim()
        },
        clickImg(item,index){   
            console.log(item,index);        
            ImagePreview({      
                images: this.infoObj.guijitupianList,     
                closeable: true,        
                startPosition: index,       
            });         
        },   
        afterRead(file){
            console.log(file);
            if(Array.isArray(file)){
                file.forEach((items,indexs)=>{
                    let params = {
                        file:items.file
                    }
                    api.getFujianApi(params).then(res => {
                        if(res){
                            this.fujianList.push({name:items.file.name,value: 'https://yrkq.yurun.com/api' + res.data})
                            this.fujianList.forEach(item=>{
                                if(item.name.indexOf('doc') > -1){
                                    item.url = require('../assets/imgs/word-img.png')
                                }else if(item.name.indexOf('xls') > -1){
                                    item.url = require('../assets/imgs/excel-img.png')
                                }else if(item.name.indexOf('pdf') > -1){
                                    item.url = require('../assets/imgs/pdf-img.png')
                                }else if(item.name.indexOf('zip') > -1){
                                    item.url = require('../assets/imgs/yasuobao-img.png')
                                }else if(item.name.indexOf('mp4') > -1){
                                    item.url = require('../assets/imgs/video.png')
                                }else if(item.name.indexOf('ppt') > -1){
                                    item.url = require('../assets/imgs/ppt-img.png')
                                }else if(item.name.indexOf('txt') > -1){
                                    item.url = require('../assets/imgs/tet-img.png')
                                }else if(item.name.indexOf('bmp') > -1 || item.name.indexOf('gif') > -1 || item.name.indexOf('jpg') > -1 || item.name.indexOf('jpeg') > -1 || item.name.indexOf('png') > -1 ){
                                    item.url = item.value
                                }else{
                                    item.url = require('../assets/imgs/wenjian-imgss.png')
                                }
                            })
                        }else{
                            Toast("上传失败,请重新上传或联系管理员")
                            this.fujianList = []
                        }
                        console.log(this.fujianList);
                    })
                    return true;
                })
            }else{
                if(file.file.type.indexOf('image') > -1 || file.file.type.indexOf('pdf') > -1 || file.file.type.indexOf('msword') > -1 || file.file.type.indexOf('officedocument') > -1 || file.file.type.indexOf('powerpoint') > -1 || file.file.type.indexOf('excel') > -1 ||file.file.type.indexOf('text') > -1){
                    const isLt10M = file.file.size / 1024 / 1024 < 10;
                    if (!isLt10M) {
                        Toast('上传附件大小不能超过 10MB!');
                        return false;
                    }else{
                        let params = {
                            file:file.file
                        }
                        api.getFujianApi(params).then(res => {
                            console.log(file);
                            if(res){
                                this.fujianList.push({name:file.file.name,value: 'https://yrkq.yurun.com/api' + res.data})
                                this.fujianList.forEach(item=>{
                                    if(item.name.indexOf('doc') > -1){
                                        item.url = require('../assets/imgs/word-img.png')
                                    }else if(item.name.indexOf('xls') > -1){
                                        item.url = require('../assets/imgs/excel-img.png')
                                    }else if(item.name.indexOf('pdf') > -1){
                                        item.url = require('../assets/imgs/pdf-img.png')
                                    }else if(item.name.indexOf('zip') > -1){
                                        item.url = require('../assets/imgs/yasuobao-img.png')
                                    }else if(item.name.indexOf('mp4') > -1){
                                        item.url = require('../assets/imgs/video.png')
                                    }else if(item.name.indexOf('ppt') > -1){
                                        item.url = require('../assets/imgs/ppt-img.png')
                                    }else if(item.name.indexOf('txt') > -1){
                                        item.url = require('../assets/imgs/tet-img.png')
                                    }else if(item.name.indexOf('bmp') > -1 || item.name.indexOf('gif') > -1 || item.name.indexOf('jpg') > -1 || item.name.indexOf('jpeg') > -1 || item.name.indexOf('png') > -1 ){
                                        item.url = item.value
                                    }else{
                                        item.url = require('../assets/imgs/wenjian-imgss.png')
                                    }
                                })
                            }else{
                                Toast("上传失败,请重新上传或联系管理员")
                                this.fujianList = []
                            }
                            
                            console.log(this.fujianList);
                        })
                        return true;
                    }
                }else{
                    Toast('您上传附件格式不支持!\n图片支持:.jpg.png.jpeg.gif.bmp.tiff;\n文件支持:.doc.docx.xls.xlsx.ppt.pptx.pdf.txt');
                    return false
                }
                
            }
        },   
        uploadHandler(){    
            
        },
        clickQuxiaoHandler(item){
            console.log(item);
            this.fujianList = this.fujianList.filter((items) => {
                return items.value != item.value
            });
            console.log(this.fujianList );
        },
        clicSubmit(){
            console.log(this.message);
            if(this.fujianList.length === 0 || this.message === ''){
                Toast('请完善加班举证信息');
            }else{
                Dialog.confirm({
                    title: '提示',
                    message: '是否确认提交加班举证信息',
                    beforeClose:this.beforeClose,
                });
            }
        },
        
        savehandler(){
            if(this.fujianList.length === 0 && this.message === ''){
                Toast('您暂无保存内容');
            }else{
                let arr = []
                this.fujianList.forEach(item=>{
                    arr.push({name:item.name,value:item.value})
                })
                let params = { 
                    id:this.infoObj.businessId,
                    workImageAnnex:arr,
                    workNotes:this.message,
                    check:4
                }
                api.getJiabanSubmitApi(params).then(res=>{
                    console.log(res);
                    if(res.data.data === '操作成功'){
                        Toast('暂存成功');
                    }else{
                        Toast('暂存失败');
                    }
                })
            }
        },
        beforeClose(action, done){
            console.log(action);
            if(action === 'confirm'){
                let arr = []
                this.fujianList.forEach(item=>{
                    arr.push({name:item.name,value:item.value})
                })
                let params = { 
                    id:this.infoObj.businessId,
                    workImageAnnex:arr,
                    workNotes:this.message,
                    check:0
                }
                api.getJiabanSubmitApi(params).then(res=>{
                    console.log(res);
                    if(res.data.data === '操作成功'){
                        if(res.data.msg === 'end'){
                            done()
                            Toast.fail({
                                message: '提交未成功，请联系hrbp完善直属主管信息后再次提交',
                                duration:4000
                            });
                        }else if(res.data.msg === ''){
                            done()
                            this.success = 'success'
                            setTimeout(() => {
                                window.location.reload()
                            },1500)
                        }
                    }else if(res.data.data === '操作失败'){
                        done()
                        this.success = 'fail'
                    }
                })
            }else{
                done()
                this.success = ''
            }
        },
        confirmHandler(){
            
        }
   }
}
</script>
<style lang='less' scoped>
.work-info{
    width: 100%;
    height: 100%;
    background-color: #f4f6fc;
    position: relative;
    .all-box-work{
            width: 100%;
            height: 100%;
            position: relative;
        }
    .info-all-main-box{
        width: 100%;
        height: 100%;
        overflow: auto;
        
        .info-box-s1{
            width: 100%;
            background-color: #fff;
            margin-bottom: 10px;
            padding: 12px;
            .pp1{
                width: 100%;
                font-size: 16px;
                color: #323232;
                letter-spacing: 0.8px;
                display: flex;
                align-items: center;
                font-weight: 600;
            }
        }
        .info-box-s2{
            width: 100%;
            background-color: #fff;
            padding: 8px;
            .info-box-s2-main{
                width: 100%;
                height: 100%;
                background-color: rgb(242,241,246);
                border-radius: 6px;
                padding: 10px 15px;
                .time-title{
                    width: 100%;
                    font-size: 15px;
                    color: #000;
                    letter-spacing: 0.5px;
                    display: flex;
                    align-items: center;
                    font-weight: 600;
                }
                .time-box{
                    width: 100%;
                    display: flex;
                    padding: 10px 0px;
                    padding-bottom: 6px;
                    .left-time{
                        width: 30px;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        padding: 6px 0px;
                        .dian{
                            width: 5px;
                            height: 5px;
                            border-radius: 50%;
                            background-color: rgb(204,204,204);
                        }
                        .line{
                            width: 2px;
                            height: 18px;
                            background-color: rgb(204,204,204);
                            border-radius: 3px;
                            margin-top: 3px;
                            margin-bottom: 3px;
                        }
                    }
                    .right-time{
                        width: calc(100% - 30px);
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        .time1{
                            width: 100%;
                            font-size: 14px;
                            color: rgb(108,108,108);
                            letter-spacing: 0.5px;
                        }
                        .time2{
                            width: 100%;
                            font-size: 14px;
                            color: rgb(108,108,108);
                            letter-spacing: 0.5px;
                        }
                    }
                }
            }
        }
        .info-box-s3{
            width: 100%;
            background-color: #fff;
            padding: 10px;
            padding-top: 0px;
            .detail-title{
                width: 100%;
                font-size: 13px;
                background-color: rgb(244,244,244);
                color: rgb(103, 102, 102);
                letter-spacing: 0.7px;
                display: flex;
                align-items: center;
                padding:5px 10px;
                border-radius: 4px;
            }
            .common-detial-title{
                width: 100%;
                font-size: 13px;
                color: rgb(126,126,126);
                letter-spacing: 0.7px;
                display: flex;
                align-items: center;
                padding:7px 10px;
                padding-left: 3px;
                border-radius: 4px;
                padding-top: 12px;
            }
            .shuoming-box{
                width: 100%;
                max-height: 78px;
                font-size: 14px;
                letter-spacing: 1px;
                overflow: auto;
                color: #000;
                padding: 5px 3px;
                padding-top: 3px;

            }
            .waibo-box{
                width: 100%;
            }
            .detial-img-box{
                width: 100%;
                white-space: nowrap;
                overflow-x: scroll;
                padding-top: 6px;
                .img-box{
                    display: inline-block;
                    width: 54px;
                    height: 54px;
                    // text-align: center;
                    overflow-x: scroll;
                    margin-right: 8px;
                    img{
                        
                        width: 54px;
                        height: 54px;
                        border-radius: 5px;
                        
                    }
                }
                
            }
            .detial-img-box::-webkit-scrollbar{display:none}
            .waibo-box-daka{
                width: 100%;
                .img-box{
                    img{
                        height: 70px;
                    }
                }
                
            }
        }
        .write-box{
            width: 100%;
            margin-top: 10px;
            .write-box-lis{
                width: 100%;
                background-color: #fff;
                margin-bottom: 10px;
                .title-box{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 13px;
                    color: #333;
                    letter-spacing: 1px;
                    background-color: #fff;
                    padding: 10px;
                    .img-must{
                        width: 15px;
                        height: 15px;
                    }
                    .span-ssd{
                        color: red;
                        font-size: 12px;
                        letter-spacing: 0.5px;
                        padding-bottom: 5px;
                    }
                    /deep/ .van-uploader{
                        .upload-add-box{
                            width: 18px;
                            height: 18px;
                            .img-upload{
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }
                .daka-img-box{
                    width: 100%;
                    padding: 0px 20px;
                    white-space: nowrap;
                    overflow-x: scroll;
                    padding-bottom: 8px;
                    .img-box{
                        display: inline-block;
                        width: 74px;
                        margin-right: 10px;
                        position: relative;
                        img{
                            width: 56px;
                            height: 50px;
                            border-radius: 5px;
                        }
                        .name-box{
                            width: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            white-space: nowrap; //禁止换行
                            overflow: hidden;
                            text-overflow: ellipsis; 
                            font-size: 12px;
                            margin-top: 4px;
                            span{
                                white-space: nowrap; //禁止换行
                                overflow: hidden;
                                text-overflow: ellipsis; 
                            }
                        }
                        .quxiao{
                            width: 15px;
                            height: 15px;
                            position: absolute;
                            right: 0px;
                            top: 0px;
                        }
                    }

                }
                .daka-img-box::-webkit-scrollbar{display:none}
                .lis-bom{
                    width: 100%;
                    background-color: #fff;
                    padding: 10px;
                    padding-top: 5px;
                    .lis-bom-main{
                        width: 100%;
                        padding: 8px;
                        border: 1px solid #eee;
                        font-size: 14px;
                        color: #74798c;
                        letter-spacing: 1.5px;
                        line-height: 23px;
                        border-radius: 4px;
                        /deep/ .van-field{
                            height: 100%;
                            padding: 0px!important;
                            font-size: 14px!important;
                            color: #74798c!important;
                            .van-field__control{
                                letter-spacing: 1.5px;
                            }
                        }
                        /deep/ .van-field__control{
                            max-height: 100px!important;
                        }
                        /deep/ .van-field__left-icon{
                            display: none;
                        }
                    }
                }
            }
        }
    }
    .info-all-main-box::-webkit-scrollbar{display:none}
    .img-zhuangtai{
        position: fixed;
        width: 65px;
        height: 65px;
        right: 20px;
        top: 40px;
    }
    .liucheng-box{
            width: 100%;
            background-color: #fff;
            margin-bottom: 8px;
            padding-top: 5px;
            .liucheng-title{
                width: 100%;
                display: flex;
                align-items: center;
                font-size: 13px;
                color: #333;
                letter-spacing: 1px;
                background-color: #fff;
                margin-bottom: 8px;
                padding: 4px 10px;
            }
            .liucheng-main-box{
                width: 100%;
                padding: 0px 20px;
                padding-bottom: 1px;
                .liucheng-main-lis{
                    width: 100%;
                    min-height: 70px;
                    margin-bottom: 10px;
                    display: flex;
                    justify-content: space-between;
                    .liucheng-lis-left{
                        width: 40px;
                        border-radius: 4px;
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        .img-touxiang{
                            width: 40px;
                            height: 40px;
                            border-radius: 4px;
                        }
                        .wai-box{
                            width: 15px;
                            height: 15px;
                            background-color: #0aa052;
                            position: absolute;
                            top: 28px;
                            left: 40px;
                            z-index: 2;
                            border-radius: 50%;
                            border: 2px solid #fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .img-last{
                                width: 10px;
                                height: 10px;
                            }
                        }
                        .shuxian-box{
                            width: 100%;
                            height: calc(100% - 40px);
                            display: flex;
                            align-items: flex-end;
                            padding-top: 5px;
                            .shuxian-main{
                                width: 2px;
                                height: 100%;
                                background-color: rgb(226,226,226);
                                border-radius: 2px;
                                margin-left: 20.5px;
                            }
                        }
                    }
                    .liucheng-lis-right{
                        width: calc(100% - 60px);
                        height: 100%;
                        padding-left: 10px;
                        position: relative;
                        .right-top-box{
                            width: 100%;
                            height: 20px;
                            color:#999;
                            letter-spacing: 0.5px;
                            font-size: 12px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding-right: 10px;
                        }
                        .right-bom-box{
                            width: 100%;
                            height: 25px;
                            display: flex;
                            align-items: center;
                            color: #000;
                            font-size: 13px;
                        }
                        .info-jujue{
                            width: 100%;
                            color:#999;
                            letter-spacing: 0.5px;
                            font-size: 12px;
                            padding-top: 2px;
                        }
                    }
                }
                .liucheng-main-lis:last-child{
                    margin-bottom: 5px;
                    .shuxian-box{
                        display: none;
                    }
                }
                
            }
    }
    .chengg-box{
        width: 100%;
        height: 100%;
        padding-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .img-success{
            width: 180px;
            height: 180px;
        }
        .text-s{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 40px;
            font-size: 16px;
            letter-spacing: 1.5px;
            color: #000;
            margin-top: 20px;
        }

    }
    .liubai-box{
        width: 100%;
        height: 50px;
    }
    .bom-submit{
        width: 100%;
        height: 50px;
        background-color: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 100;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px 8px 0px 0px;
        .caogao-box{
            width: 50px;
            height: 38px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-right: 14px;
            .img-caogao{
                width: 23px;
                height: 23px;
            }
            span{
                font-size: 12px;
                letter-spacing: 0.2px;
            }
        }
        .submit-box{
            width: 72%;
            height: 38px;
            background-color: rgb(0,134,256);
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            letter-spacing: 3px;
            color: #fff;
        }
    }
}

/deep/ .van-dialog__header{
    letter-spacing: 1.5px;
    padding-top: 20px!important;
}
/deep/ .van-dialog__content{
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.loading-box{
    width: 100%;
    height: 100%;
    .content{
        width: 150px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        position: absolute;
        top: 0px;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        div {
            width: 10px;
            height: 10px;
            background-color: blue;
            border-radius: 100%;
            display: inline-block;
            animation: action 1.5s infinite ease-in-out;
            animation-fill-mode: both;
            margin-right: 8px;
        }
        .point1 {
            animation-delay: -0.3s;
        }
        .point2 {
            animation-delay: -0.1s;
        }
    }
    @keyframes action {
        0%, 80%, 100% {
            transform: scale(0);
        }
        40% {
            transform: scale(1.0);
        }
    }
}
</style>